import { useAppTranslation } from 'services/i18n';

export const PreviewBanner = () => {
  const t = useAppTranslation();

  return (
    <div className="tw-flex tw-h-40 tw-w-full tw-shrink-0 tw-items-center tw-justify-center tw-gap-8 tw-bg-lightInfo">
      <div className="tw-flex tw-h-16 tw-w-16 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-1/2 tw-bg-info tw-text-[11px] tw-font-bold tw-leading-none tw-text-white">
        i
      </div>
      <span className="tw-text-14 tw-leading-none tw-font-medium tw-text-darkestGray">
        {t('contentViewer.previewBar.info')}
        <span className="tw-hidden sm:tw-inline">{t('contentViewer.previewBar.infoNoProgress')}</span>
      </span>
    </div>
  );
};
